import PubSub, { Message } from "../Utils/pubSub";

export class TrackingService {
  static shouldTrack = false;

  static startTracking({ ga = [], gtm = '', }) {
    this.shouldTrack = true;
    PubSub.publish(Message.InitTracking, {
      gaKey: ga,
      gtmKey: gtm && [gtm],
    });
  }

  static track(args) {
    if (this.shouldTrack === false) return;
    PubSub.publish(Message.Track, { ...args })
  }

  static trackError(error) {
    if (this.shouldTrack === false) return;
    // TODO: log to sentry
    console.error(error);
  }

  static trackViewItem(item) {
    try {
      const ecommerce = {
        currency: "USD",
        value: Number(item.sizes[0]?.price),
        items: [
          {
            item_id: item.id,
            item_name: item.name,
            item_brand: item.brand,
            item_category: item.category,
            item_category2: item.type,
            item_variant: item.sizes[0]?.productId?.toString(),
            price: Number(item.sizes[0]?.price),
            quantity: 1,
          }
        ]
      };

      TrackingService.track({ ecommerce: null })
      TrackingService.track({ event: "view_item_list", ecommerce });
      TrackingService.track({ ecommerce: null })
      TrackingService.track({ event: "view_item", ecommerce });
    } catch (error) {
      TrackingService.trackError(error);
    }
  }

  static trackAddToCart(item, price, quantity) {
    try {
      const ecommerce = {
        currency: "USD",
        value: Number(price),
        items: [
          {
            item_id: item.id,
            item_name: item.name,
            item_brand: item.brand,
            item_category: item.category,
            item_category2: item.type,
            item_variant: item.sizes[0]?.productId.toString(),
            price: Number(price),
            quantity: quantity,
          }
        ]
      };

      TrackingService.track({ event: "add_to_cart", ecommerce });
    } catch (error) {
      TrackingService.trackError(error);
    }
  }

  static trackRemoveFromCart(item) {
    try {
      const ecommerce = {
        currency: "USD",
        value: Number(item.product.price),
        items: [
          {
            item_id: item.bundleExternalId || item.productGroupingId,
            item_name: item.productGrouping.name,
            item_brand: item.productGrouping.brand,
            item_category: item.productGrouping.category,
            item_category2: item.productGrouping.type,
            item_variant: item.product.productId.toString(),
            price: Number(item.product.price),
            quantity: item.quantity,
          }
        ]
      };

      TrackingService.track({ event: "remove_from_cart", ecommerce });
    } catch (error) {
      TrackingService.trackError(error);
    }
  }

  static trackViewCart(cart) {
    try {
      const items = cart.cartItems || cart.items || [];
      const ecommerce = {
        currency: "USD",
        value: Number(cart.subtotal),
        items: items?.map((item) => ({
          item_id: item.productGroupingId,
          item_name: item.productGrouping.name,
          item_brand: item.productGrouping.brand,
          item_category: item.productGrouping.category,
          item_category2: item.productGrouping.type,
          item_variant: item.product.productId.toString(),
          price: Number(item.product.price),
          quantity: item.quantity,
        }))
      };

      TrackingService.track({ event: "view_cart", ecommerce });
    } catch (error) {
      TrackingService.trackError(error);
    }
  }
}
